import { InputText } from "primereact/inputtext";
import type {
  FieldError,
  FieldValues,
  Path,
  UseFormRegister,
} from "react-hook-form";
import authStyles from "@/components/AuthCard.module.css";
import { EMAIL_PATTERN } from "@/utils/validation";

interface EmailFieldValues extends FieldValues {
  email: string;
}

interface EmailFieldProps<TFieldValues extends EmailFieldValues> {
  error?: FieldError;
  invalidMessage: string;
  label: string;
  register: UseFormRegister<TFieldValues>;
  requiredMessage: string;
}

// Shared by LoginForm and ResetPasswordForm, whose email fields are
// identical apart from which TEXT.auth.* namespace supplies the copy.
const EmailField = <TFieldValues extends EmailFieldValues>({
  error,
  invalidMessage,
  label,
  register,
  requiredMessage,
}: EmailFieldProps<TFieldValues>) => (
  <div className={authStyles.field}>
    <label className={authStyles.label} htmlFor="email">
      {label}
    </label>
    <InputText
      className={authStyles.input}
      id="email"
      type="email"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...register("email" as Path<TFieldValues>, {
        pattern: {
          message: invalidMessage,
          value: EMAIL_PATTERN,
        },
        required: requiredMessage,
      })}
    />
    {error && (
      <span className={authStyles.error} role="alert">
        {error.message}
      </span>
    )}
  </div>
);

export default EmailField;
